import { h } from 'preact';
import Store from 'store/store';
import * as jsonPointer from 'utils/jsonPointer';

import CardSelect from 'components/cardSelect/cardSelect';
import FieldBase from 'components/editor/settings/fieldBase';

export default class CardSelectField extends FieldBase {
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
	}

	// A single <label> cannot wrap a group of radios, so keep the wrapper a plain <div>
	get labelFor() {
		return null;
	}

	onChange(e) {
		this.props.onInput?.(e);
		if (!this.props.path) return;
		jsonPointer.setDeep(Store.get().data, this.props.path, e.target.value);
	}

	renderField() {
		const props = this.props;

		return (
			<CardSelect
				key="field"
				name={props.name}
				label={props.label}
				value={this.getValue()}
				dark={props.dark}
				disabled={this.disabled || this.readonly}
				onChange={this.onChange}
			>
				{props.children}
			</CardSelect>
		);
	}
}
